import Axios from "axios";
import { useEffect, useState } from "react";
import { guestServiceProvider } from "../services/ServiceProvider";
import { convertArrayToObject } from "../utils/helpers";

export interface IUseRoomDetail {
  hotelCode: string;
  roomCode?: string;
  resId?: string;
  crsName?: string;
}

export const useRoomDetail = (props: IUseRoomDetail): any => {
  const [loadingRoomDetail, setLoadingRoomDetail] = useState(false);
  const [roomDetail, setRoomDetail] = useState(null);
  const [allRooms, setAllRooms] = useState(null);

  // Fetch room details.
  useEffect(() => {
    const source: any = Axios.CancelToken.source();
    let didCancel = false;

    (async () => {
      if (props.hotelCode || props.resId) {
        setLoadingRoomDetail(true);
        const guestService = await guestServiceProvider();
        const getHotelDetails = await guestService.getHotelDetails(
          props?.hotelCode
        );
        const allRoomsWithoutRates = convertArrayToObject(
          getHotelDetails?.hotel?.rooms,
          "code"
        );
        setAllRooms(allRoomsWithoutRates);
        setRoomDetail(
          getHotelDetails?.hotel?.rooms.find(
            (room: any) => room?.code === props?.roomCode
          )
        );

        if (!didCancel) {
          setLoadingRoomDetail(false);
        }
      }
    })();

    return () => {
      didCancel = true;
      source.cancel(`Request cancelled for fetch room details`);
    };
  }, [props.hotelCode, props.roomCode]);

  return [loadingRoomDetail, roomDetail, allRooms];
};
